var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"dcw-play-button",attrs:{"aria-label":_vm.translation.buttons.playVideo,"type":"button"}},[_c('PlayIcon',{staticClass:"dcw-play-button__triangle"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }